import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';

import { takeUntil } from 'rxjs/operators';
import { NewsService } from 'src/app/core/services/news.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detail',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit,OnDestroy {
  domainURL=environment.domain+"/"+(this.localId+"").substring(0,2)+"/";
  detail: any;
  toYear=(new Date()).getFullYear();
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    @Inject(LOCALE_ID) private localId: Object,
    @Inject(PLATFORM_ID) private platformId: Object,
    public router: Router,
    private route: ActivatedRoute,
    public newsService: NewsService,
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)||isPlatformServer(this.platformId)) {

      this.route.paramMap.subscribe((params) => {
        const paramUrl= params.get('id');;
        this.getNewsDetail(paramUrl);
      });
    }
  }

  getNewsDetail(paramUrl) {
    this.newsService.getByUrl(paramUrl).pipe(takeUntil(this.destroy$)).subscribe({next: data => {
      this.detail=data;
    },
    error: error => {
    }});
  }


}
